<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card bg-pattern">
                    <img src="@/assets/images/header.jpg" class="card-img-top" alt="...">
                    <!-- <div class="card-header bg-success">
                        <div class="text-center">
                            <img src="@/assets/logo-vertical.png" alt height="150" />
                        </div>
                    </div> -->
                    <div class="card-body p-4">
                        <form v-if="step == 1" action="" class="form-box" @submit.prevent="validateForm" novalidate>
                            <FormInput name="AgentId" type="text"
                                label="กรุณากรอกรหัสสมาชิก (ใส่เฉพาะตัวเลข 8 หลักเท่านั้น ไม่ต้องใส่ AM/AML)"
                                v-model="values.AgentId" placeholder="รหัสสมาชิก (รหัส AML)" @validate="validate"
                                formGroupClass="form-group" :error="errors.AgentId" />
                            <div class="text-center mt-3">
                                <button type="submit" class="btn btn-primary d-flex m-auto align-items-center">
                                    <div>ยืนยันข้อมูล</div>
                                    <div v-show="IsSubmit" class="spinner-border spinner-border-sm ml-2" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </div>
                        </form>
                        <div v-else class="form-box text-center">
                            <div>กรุณาตรวจสอบอีเมลของท่าน</div>
                            <div class="form-group my-3">
                                <input id="email" type="text" class="form-control text-center" disabled
                                    v-model="maskedEmail">
                            </div>
                            <div>
                                ระบบได้ส่งลิ๊งค์เปลี่ยนรหัสผ่านใหม่ให้ท่านทางอีเมลเรียบร้อยแล้ว
                            </div>
                        </div>
                        <section class="text-center mt-4 pb-2">
                            <h5>กลับไปหน้าเข้าสู่ระบบ ?</h5>
                            <div>
                                <router-link :to="{ name: 'login' }">ล็อกอินเพื่อเข้าสู่ระบบที่นี่</router-link>
                                <br>
                            </div>
                        </section>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<script>
import Layout from '@/components/layouts/auth'
export default {
    name: 'ForgetPassword',
    components: { Layout },
    data() {
        var yup = this.yup
        return {
            step: 1,
            webUrl: process.env.VUE_APP_WEB_URL,
            IsSubmit: false,
            maskedEmail: "",
            values: {
                AgentId: "",
            },
            errors: {
                AgentId: "",
            },
            FormSchema: yup.object().shape({
                AgentId: yup.string().matches(/^\d{8}$/, 'กรุณากรอกรหัสสมาชิกเป็นตัวเลข 8 หลัก').required(),
            })
        };
    },
    mounted() {
        //this.$store.commit('setSubMenu',0);
    },
    methods: {
        clickLogin() {
            let self = this;
            this.IsSubmit = true;
            this.axios.post(process.env.VUE_APP_OFFICEAPI_URL + '/api/resetpassword', this.values)
                .then(function (res) {
                    if (res.status == 200) {
                        self.maskedEmail = res.data;
                        self.step = 2;
                    } else {
                        self.$swal('ไม่พบข้อมูลในระบบ');
                    }
                    self.IsSubmit = false;
                })
                .catch(function (error) {
                    self.$swal('เกิดข้อผิดพลาด');
                    self.IsSubmit = false;
                });
        },
        validateForm() {
            this.FormSchema
                .validate(this.values, { abortEarly: false })
                .then(() => {
                    this.clickLogin()
                })
                .catch(err => {
                    err.inner.forEach(error => {
                        this.errors = { ...this.errors, [error.path]: error.message };
                    });
                });
        },
        validate(field) {
            this.FormSchema
                .validateAt(field, this.values)
                .then(() => {
                    this.errors[field] = "";
                })
                .catch(err => {
                    this.errors[err.path] = err.message;
                });
        }
    }
}
</script>
